<template>
    <span class="speaker-icon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            version="1.1"
            viewBox="0 0 29 29"
            xml:space="preserve"
        >
            <path
                :fill="fill"
                d="M12.657 23.415a1.83 1.83 0 01-1.146-.406L6.85 19.28H3.84A1.842 1.842 0 012 17.44v-5.88c0-1.015.825-1.84 1.84-1.84h3.01l4.661-3.729a1.826 1.826 0 011.946-.222c.644.31 1.043.945 1.043 1.659v14.145c0 .714-.399 1.349-1.043 1.658-.256.123-.53.184-.8.184zM4 17.28h3.2c.227 0 .447.077.625.219l4.675 3.74V7.761l-4.675 3.74a1.001 1.001 0 01-.625.219H4v5.56zM19.803 20.803a.999.999 0 01-.707-1.707C20.306 17.887 21 16.211 21 14.5s-.694-3.387-1.904-4.596A.999.999 0 1120.51 8.49C22.092 10.071 23 12.262 23 14.5s-.908 4.429-2.49 6.01a.993.993 0 01-.707.293z"
            />
            <path
                :fill="fill"
                d="M22.632 23.632a.999.999 0 01-.707-1.707C23.879 19.97 25 17.264 25 14.5s-1.121-5.47-3.075-7.425a.999.999 0 111.414-1.414C25.666 7.988 27 11.209 27 14.5s-1.334 6.512-3.661 8.839a.997.997 0 01-.707.293zM16.975 17.975a1 1 0 01-.707-1.707c.465-.465.732-1.11.732-1.768s-.267-1.303-.732-1.768a1.002 1.002 0 010-1.415 1.002 1.002 0 011.415 0C18.52 12.156 19 13.316 19 14.5s-.48 2.344-1.317 3.182a1.001 1.001 0 01-.708.293z"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconSpeaker',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
